import axios from 'axios'

import config from '../../config'

const deleteAuthRole = (params = {}, authRoleId) => {
  const { airportId, id } = params

  const url = `${config.baseUrl}/${airportId}/AuthRoles/${id}`
  return axios.delete(url)
}

export default deleteAuthRole
